import React from 'react';
import './App.css';


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeroBanner from './components/HeroBanner';
import AboutPage from './pages/About';
import ProductsPage from './pages/Products';
import ContactPage from './pages/Contact';
import ProcessPage from './pages/Process';
// import GalleryPage from './pages/Gallery';

// Add other pages as needed

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HeroBanner />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* <Route path="/gallery" element={<GalleryPage />} /> */}
        {/* Add more routes here */}
      </Routes>
    </Router>
  );
}


export default App;